import { Tooltip, TooltipProps } from '@chakra-ui/react'
import { cloneElement, memo, ReactElement } from 'react'

import { useDetectOverflow } from '@/hooks/useDetectOverflow'

interface TextOverflowTooltipProps extends TooltipProps {
  children: ReactElement
}

export const TextOverflowTooltip = memo(({ children, ...rest }: TextOverflowTooltipProps) => {
  const [overflow, ref] = useDetectOverflow()

  return (
    <Tooltip {...rest} isDisabled={!overflow}>
      {cloneElement(children, { ...children.props, ref })}
    </Tooltip>
  )
})

TextOverflowTooltip.displayName = 'TextOverflowTooltip'
